<template>
  <div class="system-settings">
    <el-card shadow="hover">
      <div slot="header" class="clearfix">
        <span class="header-title">系统设置</span>
      </div>
      
      <el-form :model="configForm" label-width="150px" class="config-form">
        <el-form-item label="管理员QQ号">
          <el-input v-model="configForm.admin_qq" placeholder="请输入管理员QQ号" style="width: 300px;"></el-input>
        </el-form-item>
        
        <el-form-item label="赞助微信二维码">
          <div class="qrcode-upload">
            <el-upload
              class="qrcode-uploader"
              :action="uploadUrl"
              :show-file-list="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              accept="image/*"
            >
              <div v-if="configForm.wechat_qrcode" class="qrcode-preview">
                <img :src="baseUrl + configForm.wechat_qrcode" class="qrcode-img" />
                <div class="qrcode-mask">
                  <i class="el-icon-edit"></i>
                  <span>更换图片</span>
                </div>
              </div>
              <div v-else class="qrcode-placeholder">
                <i class="el-icon-plus"></i>
                <p>上传二维码</p>
              </div>
            </el-upload>
            <p class="upload-tip">建议上传正方形图片，大小不超过2MB</p>
          </div>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="saveConfig" :loading="saving">保存设置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AdminSystemSettings',
  data() {
    return {
      configForm: {
        admin_qq: '',
        wechat_qrcode: ''
      },
      saving: false,
      baseUrl: this.$axios.defaults.baseURL,
      uploadUrl: this.$axios.defaults.baseURL + '/system/upload-qrcode'
    }
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    loadConfig() {
      this.$axios.get('/system/config').then(res => {
        if (res.code === 200) {
          this.configForm = res.data
        }
      }).catch(error => {
        console.error('获取系统配置失败:', error)
      })
    },
    saveConfig() {
      this.saving = true
      this.$axios.post('/system/config', this.configForm).then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.message || '保存失败')
        }
      }).catch(error => {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      }).finally(() => {
        this.saving = false
      })
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件！')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！')
        return false
      }
      return true
    },
    handleUploadSuccess(response) {
      if (response.code === 200) {
        this.configForm.wechat_qrcode = response.data.url
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },
    handleUploadError() {
      this.$message.error('上传失败')
    }
  }
}
</script>

<style scoped>
.system-settings {
  padding: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
}

.config-form {
  max-width: 600px;
  margin-top: 20px;
}

.qrcode-upload {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.qrcode-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.3s;
}

.qrcode-uploader:hover {
  border-color: #409EFF;
}

.qrcode-preview {
  width: 180px;
  height: 180px;
  position: relative;
}

.qrcode-preview .qrcode-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qrcode-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s;
}

.qrcode-preview:hover .qrcode-mask {
  opacity: 1;
}

.qrcode-mask i {
  font-size: 24px;
  margin-bottom: 8px;
}

.qrcode-placeholder {
  width: 180px;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #909399;
}

.qrcode-placeholder i {
  font-size: 40px;
  margin-bottom: 10px;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 10px;
}
</style>
